import {TransactionDirection, TransactionStatus} from '@sollapay/enums';

import type {PaymentMethod} from '@sollapay/enums';
import type {CreatedAtFilter} from '@sollapay/ui/components';

export type {CreatedAtFilter};

export const CREATED_AT_FILTER_VALUES: CreatedAtFilter[] = ['all', 'this_week', '7d', '30d', '90d'];

export const TRANSACTIONS_FILTER_QUERY_PARAMS = ['datePreset', 'direction', 'status'] as const;

export interface TransactionsFilterState {
  datePreset: CreatedAtFilter;
  amountMin?: number;
  amountMax?: number;
  initiationMethods: PaymentMethod[];
  directions: TransactionDirection[];
  statuses: TransactionStatus[];
}

export const DEFAULT_TRANSACTIONS_FILTER_STATE: TransactionsFilterState = {
  datePreset: 'all',
  initiationMethods: [],
  directions: [],
  statuses: []
};

export function parseFilterFromSearchParams(
  searchParams: URLSearchParams,
  defaults: TransactionsFilterState
): TransactionsFilterState {
  const datePreset = searchParams.get('datePreset');
  const direction = searchParams.get('direction');
  const status = searchParams.get('status');
  return {
    ...defaults,
    datePreset:
      datePreset && CREATED_AT_FILTER_VALUES.includes(datePreset as CreatedAtFilter)
        ? (datePreset as CreatedAtFilter)
        : defaults.datePreset,
    directions:
      direction && Object.values(TransactionDirection).includes(direction as TransactionDirection)
        ? [direction as TransactionDirection]
        : defaults.directions,
    statuses:
      status && Object.values(TransactionStatus).includes(status as TransactionStatus)
        ? [status as TransactionStatus]
        : defaults.statuses
  };
}
